import { DocumentResourceV4 } from '@models/resources/document.model';

/**
 * V4-Demo-Daten für die Customer-Dokumentenliste (Sprint 5c S5c-12).
 *
 * Nur kundensichtbare Dokumente (BE filtert serverseitig auf
 * `visible_to_customer=true` + eigener `customer_id`). Wire-Shape matched
 * `DocumentResource::toArray()` 1:1.
 *
 * `download_url` zeigt auf den Streaming-Endpoint und wird im Dummy-Mode
 * nicht verwendet — der Demo-Download liefert das Placeholder-PDF aus
 * `assets/demo/placeholder.pdf`.
 *
 * Lagergebühr-PDFs (Type `storage_fee_invoice`, V3-Delta) tauchen
 * hier ebenfalls auf — sie werden in die Customer-Dokumentenliste
 * eingemischt und sind über den Klassifizierungs-Filter eingrenzbar
 * (Tech-Konzept §7.4).
 */
export const DEMO_DOCUMENTS_V4: DocumentResourceV4[] = [
  {
    id: 1,
    type: 'contract',
    title: 'Depoteröffnungsvertrag',
    filename: 'depot-vertrag-2024-03-12.pdf',
    mime_type: 'application/pdf',
    file_size: 284_312,
    download_url: '/api/documents/1/download',
    created_at: '2024-03-12T10:15:00+01:00',
  },
  {
    id: 2,
    type: 'report',
    title: 'Jahresbericht 2024',
    filename: 'jahresbericht-2024.pdf',
    mime_type: 'application/pdf',
    file_size: 1_842_004,
    download_url: '/api/documents/2/download',
    created_at: '2025-01-15T09:00:00+01:00',
  },
  {
    id: 3,
    type: 'confirmation',
    title: 'Kaufbestätigung RE-2026-000097',
    filename: 'kaufbestaetigung-2026-000097.pdf',
    mime_type: 'application/pdf',
    file_size: 162_880,
    download_url: '/api/documents/3/download',
    created_at: '2026-03-29T14:42:00+01:00',
  },
  {
    id: 4,
    type: 'confirmation',
    title: 'Kaufbestätigung RE-2026-000094',
    filename: 'kaufbestaetigung-2026-000094.pdf',
    mime_type: 'application/pdf',
    file_size: 158_210,
    download_url: '/api/documents/4/download',
    created_at: '2026-03-15T11:30:00+01:00',
  },
  {
    id: 5,
    type: 'report',
    title: 'Quartalsreport Q1 2026',
    filename: 'q1-2026-report.pdf',
    mime_type: 'application/pdf',
    file_size: 956_112,
    download_url: '/api/documents/5/download',
    created_at: '2026-04-04T08:20:00+02:00',
  },
  {
    id: 8,
    type: 'contract',
    title: 'AGB 2024',
    filename: 'agb-2024.pdf',
    mime_type: 'application/pdf',
    file_size: 624_890,
    download_url: '/api/documents/8/download',
    created_at: '2024-01-01T00:00:00+01:00',
  },
  {
    id: 9,
    type: 'report',
    title: 'Halbjahresbericht 2025',
    filename: 'halbjahresbericht-2025.pdf',
    mime_type: 'application/pdf',
    file_size: 1_204_360,
    download_url: '/api/documents/9/download',
    created_at: '2025-07-02T09:15:00+02:00',
  },
  {
    id: 10,
    type: 'other',
    title: 'Steuerbescheinigung 2024',
    filename: 'steuer-2024.pdf',
    mime_type: 'application/pdf',
    file_size: 398_554,
    download_url: '/api/documents/10/download',
    created_at: '2025-02-28T13:00:00+01:00',
  },
  // --- Lagergebühr-Rechnungen (V3-Delta, in Customer-Doc-Liste eingemischt)
  {
    id: 11,
    type: 'storage_fee_invoice',
    title: 'Lagergebühr RE-2026-010045 H1',
    filename: 'lagergebuehr-2026-010045.pdf',
    mime_type: 'application/pdf',
    file_size: 148_220,
    download_url: '/api/documents/11/download',
    created_at: '2026-07-01T08:00:00+02:00',
  },
  {
    id: 12,
    type: 'storage_fee_invoice',
    title: 'Lagergebühr RE-2025-010038 H2',
    filename: 'lagergebuehr-2025-010038.pdf',
    mime_type: 'application/pdf',
    file_size: 146_040,
    download_url: '/api/documents/12/download',
    created_at: '2026-01-02T08:00:00+01:00',
  },
  {
    id: 13,
    type: 'storage_fee_invoice',
    title: 'Lagergebühr RE-2025-010022 H1',
    filename: 'lagergebuehr-2025-010022.pdf',
    mime_type: 'application/pdf',
    file_size: 145_120,
    download_url: '/api/documents/13/download',
    created_at: '2025-07-01T08:00:00+02:00',
  },
  {
    id: 14,
    type: 'storage_fee_invoice',
    title: 'Lagergebühr RE-2024-010017 Jahresabrechnung',
    filename: 'lagergebuehr-2024-010017.pdf',
    mime_type: 'application/pdf',
    file_size: 156_780,
    download_url: '/api/documents/14/download',
    created_at: '2025-01-02T08:00:00+01:00',
  },
];
